import { RestApi } from './base/RestApi';

export interface IShop {
	address: {
		address_extra: string;
		city: string;
		distance: number;
		federal_state: string;
		latitude: number;
		longitude: number;
		postal_code: string;
		street: string;
		street_number: string;
	};
	closed: boolean;
	contact: {
		email: string;
		fax_number: string;
		phone_number: string;
	};
	id: string;
	images: {
		thumbnail: string;
		small: string;
		medium: string;
		big: string;
		original: string;
	};
	kind: 'pa' | string;
	languages: string[];
	name: string;
	opening_times: {
		deviations: unknown[];
		is_open: boolean;
		opening_hours: Record<string, unknown>;
	};
	properties: {
		agreement_type: 'option' | string;
		exclusive_partner: boolean;
		final_closure_date: string; //"2014-04-17"
		initial_opening_date: string; //"2014-04-17"
		owner_type: string; //"Partner Shop";
		predecessor_shop_vpnr: string;
		region: string; // "West";
		sales_no: string; //"TPC93";
		shop_building: string;
		successor_shop_vpnr: string;
		url: string;
	};
	services: {
		appointments: boolean;
		business: boolean;
		click_and_collect: boolean;
		customer_frequency_measurement: boolean;
		magenta_events: boolean;
		repair: boolean;
		router_exchange: boolean;
		service_counter: boolean;
		smart_home: boolean;
	};
	type: 'tsg' | string;
	vpnr: string; //"9949292"
}

export class ShopsApi extends RestApi<IShop> {
	constructor(path = '/shops') {
		super(path);
	}
}
